import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const money = (v, currency = "AUD") =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency }).format(Number(v || 0));

export const computeTotals = (q) => {
  const rate = Number(q.gst_rate || 0) / 100;
  const inclusive = !!q.prices_include_gst;
  let taxableEx = 0;
  let freeEx = 0;
  (q.line_items || []).forEach((li) => {
    const gross = Number(li.qty || 0) * Number(li.unit_price || 0);
    if (li.taxable !== false) taxableEx += inclusive && rate ? gross / (1 + rate) : gross;
    else freeEx += gross;
  });
  const subtotalEx = taxableEx + freeEx;
  const dval = Number(q.discount_value || 0);
  let discount = 0;
  if (q.discount_type === "percent") discount = (subtotalEx * dval) / 100;
  else if (q.discount_type === "fixed") discount = inclusive && rate ? dval / (1 + rate) : dval;
  discount = Math.min(discount, subtotalEx);
  const ratio = subtotalEx === 0 ? 0 : (subtotalEx - discount) / subtotalEx;
  const gst = taxableEx * ratio * rate;
  return {
    subtotal_ex_gst: subtotalEx,
    discount_amount: discount,
    gst_amount: gst,
    total_inc_gst: subtotalEx - discount + gst,
    gst_free_amount: freeEx * ratio,
  };
};
